import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import * as Icons from './icons'
import { fetchNewChatbotState, fetchChatbotState } from '../../redux/reducers';
import { getRouter, getLocalStorage } from '../../utils/helper';
import styles from "./index.scss";
import jwt from "jsonwebtoken";
import Cookies from "universal-cookie";
const Chatbot = (props) => {
  const cookie = new Cookies();
  let user = cookie.get("user"); //  用户信息
  let chatbotData = getLocalStorage("chatbot"); //  舊版本
  let ContentStackData = getLocalStorage("adaChatBot"); //  新版本
  const { NextHead, excludeInURL } = props;
  const dispatch = useDispatch();
  const Head = NextHead || "head";
  const route = getRouter();
  //  獲取 PDP redux 中頁面上報詳情信息
  const stateProductDetails = useSelector((state) => {
    if (state.setChatBotDetails && JSON.stringify(state.setChatBotDetails) !== "{}") {
      return state.setChatBotDetails
    } else {
      return null
    }
  });
  const [ChatBotReady, setChatBotReady] = useState(false);// Chatbot 腳本加載完成
  const [backToTopIcon, setBackToTopIcon] = useState('');
  const [unrestrictedPath, setUnrestrictedPath] = useState(false); // 無限制路徑
  const [enabled, setEnabled] = useState(false); // Content Stack 開關
  const [showChatBotButton, setShowChatBotButton] = useState(false);
  const [backToTopVisible, setBackToTopVisible] = useState(false);
  const [productDetails, setProductDetails] = useState(null)
  const [sensitiveMetaFields, setSensitiveMetaFields] = useState(null)

  //  回到頁面頂端 相關功能代碼片段
  const toggleBackToTop = () => {
    const scrolled = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0;
    if (scrolled == 0) {
      setBackToTopVisible(false)
    }
    else {
      setBackToTopVisible(true);
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  if (typeof window !== "undefined" && typeof window !== undefined) {
    window.addEventListener('scroll', toggleBackToTop);
  }
  const ADA_BUTTON_FRAME_BLOCK = `
  #ada-button-frame {
    display: block !important;
    z-index: 990 !important;
  }
  `
  const ADA_BUTTON_FRAME_NONE = `
  #ada-button-frame {
    display: none !important;
  }
  `
  //  PDP Product Details
  useEffect(() => {
    if (stateProductDetails)
      setProductDetails(stateProductDetails)
  }, [stateProductDetails])

  //  排除 路由
  useEffect(() => {
    if (route?.asPath && excludeInURL.includes(route.asPath.split('?')[0].toLowerCase())) {
      setUnrestrictedPath(false)
    } else {
      setUnrestrictedPath(true)
    }
  }, [route])

  //  初始化  上報用戶信息
  useEffect(() => {
    if (typeof window !== "undefined" && typeof window !== undefined) {
      window.adaSettings = {
        language: "zh-tw",
        adaReadyCallback: () => {
          setChatBotReady(true)
        }
      }
      if (user && user !== "undefined" && Object.keys(user).length !== 0 && sensitiveMetaFields == null) {
        const userInfo = {
          aboNumber: `${cookie.get("mainName")}`,
          memberType: `${cookie.get("role")}`,
          Channelid: 'ec',
        }
        const now = new Date();
        const expiresIn = 60 * 30; // 0.5小时过期
        const exp = Math.floor(now.getTime() / 1000) + expiresIn;
        const JWT_SECRET_KEY = 'f1b6aa17432e5811';
        const JWT_SUGN = jwt.sign({ ...userInfo, exp: exp }, JWT_SECRET_KEY);
        const sensitiveMetaFields = {
          jwt_token: JWT_SUGN
        }
        setSensitiveMetaFields(sensitiveMetaFields)
      }
    }
  }, [route]);
  useEffect(() => {
    if (sensitiveMetaFields) {
      setAdaSensitiveMetaFields(sensitiveMetaFields)
    }
  }, [sensitiveMetaFields])
  //  Content Stack 舊版本 ChatBot 開關狀態
  useEffect(() => {
    if (chatbotData == undefined || chatbotData === "undefined" || Object.keys(chatbotData).length == 0) {
      dispatch(fetchChatbotState()).then((res) => {
        if (res) {
          setBackToTopIcon(res[0]?.back_to_top_icon?.url ?? Icons?.BackToTop?.default);
        }
      })
    }
    else {
      if (!chatbotData._version && Array.isArray(JSON.parse(chatbotData)) && JSON.parse(chatbotData).length > 0)
        chatbotData = JSON.parse(chatbotData)[0];
      setBackToTopIcon(chatbotData?.back_to_top_icon?.url ?? Icons?.BackToTop?.default);

    }
  }, [Object.keys(chatbotData).length]);

  //  Content Stack 新版本 ChatBot 開關狀態
  useEffect(() => {
    if (ContentStackData == undefined || ContentStackData === "undefined" || Object.keys(ContentStackData).length == 0) {
      dispatch(fetchNewChatbotState()).then((res) => {
        setEnabled(res?.enabled)
      })
    } else {
      setEnabled(ContentStackData?.enabled)
    }
  }, [Object.keys(ContentStackData).length]);


  // 設置 ChatBot UI 狀態
  useEffect(() => {
    if (typeof window !== "undefined" && ChatBotReady) {
      if (enabled && unrestrictedPath) {
        localStorage.setItem("showChatBotButton", true)
        setShowChatBotButton(true)
      } else {
        localStorage.setItem("showChatBotButton", true)
        setShowChatBotButton(false)
      }
    };
  }, [enabled, ChatBotReady, unrestrictedPath])
  //  上報 ChatBot PDP 商品訊息
  useEffect(() => {
    if (
      typeof window !== undefined &&
      typeof window !== "undefined" &&
      enabled &&
      ChatBotReady &&
      productDetails
    ) {
      bindReportProductDetails()
    }
  }, [productDetails, enabled, ChatBotReady, unrestrictedPath]);
  const bindReportProductDetails = useCallback(() => {
    setAdaSettingsMetaFields(productDetails)
  }, [productDetails]);

  //  设置 window.adaSettings.metaFields
  const setAdaSettingsMetaFields = (metaFields) => {
    const adaSettings = window.adaSettings ?? {}
    const metaFieldsDetails = window.adaSettings.metaFields ?? {}
    window.adaSettings = {
      ...adaSettings,
      metaFields: {
        ...metaFieldsDetails,
        ...metaFields
      }
    }
  }
  //  设置 window.adaSettings.sensitiveMetaFields
  const setAdaSensitiveMetaFields = (sensitiveMetaFields) => {
    const adaSettings = window.adaSettings ?? {}
    const sensitiveMetaFieldDetails = window.adaSettings.sensitiveMetaFields ?? {}
    if (window.adaSettings && window.adaEmbed) {
      window.adaEmbed?.reset({
        ...adaSettings,
        sensitiveMetaFields: {
          ...sensitiveMetaFieldDetails,
          ...sensitiveMetaFields
        }
      })
    }
  }

  if (typeof window == undefined || typeof window == "undefined") return null
  return (
    <>
      <Head>

        <script id="__ada" data-handle="amway-tw-uat" src="https://static.ada.support/embed2.js" ></script>
        {
          showChatBotButton ?
            <style
              dangerouslySetInnerHTML={{
                __html: ADA_BUTTON_FRAME_BLOCK,
              }}
            ></style> :
            <style
              dangerouslySetInnerHTML={{
                __html: ADA_BUTTON_FRAME_NONE,
              }}
            ></style>
        }
      </Head>
      {unrestrictedPath && backToTopVisible && enabled && <div className={styles.backToTop} onClick={scrollToTop}><img src={backToTopIcon}></img></div>}
    </>
  );
};
//API
Chatbot.defaultProps = {
  //訪問設備
  excludeInURL: [],

};

//參數類型
Chatbot.propTypes = {
  excludeInURL: PropTypes.any,

};
export default Chatbot;
